// Small text helpers.

/**
 * Up to two initials from a person's name, for Avatar's fallback.
 * Guards against empty or single-word names so a missing name can't crash a
 * whole page on `s[0]` of undefined.
 */
export const initials = (name) =>
  String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join('');
